import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary, Provider as RollbarProvider } from "@rollbar/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import Analytics from "analytics";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { AnalyticsProvider } from "use-analytics";
import { analyticsConfig } from "~/client/analytics";
import AgreementRequired from "~/client/components/AgreementRequired";
import InitializationRequired from "~/client/components/InitializationRequired";
import { ExtensionProvider } from "~/client/contexts/ExtensionContext";
import { UserProvider } from "~/client/contexts/UserContext";
import router from "~/client/router";
import theme from "~/client/theme";
import { rollbarConfig } from "~/shared/rollbar";
import "~/client/index.css";
const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});
const analytics = Analytics(analyticsConfig);
const root = createRoot(document.querySelector("#root"));
root.render(_jsx(StrictMode, { children: _jsx(RollbarProvider, { config: rollbarConfig, children: _jsx(ErrorBoundary, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(AgreementRequired, { children: _jsx(AnalyticsProvider, { instance: analytics, children: _jsx(InitializationRequired, { children: _jsx(ExtensionProvider, { children: _jsx(UserProvider, { children: _jsx(RouterProvider, { router: router }) }) }) }) }) }) }) }) }) }) }));
